import { ReactNode } from 'react';

export type SkeletonGroupSkin = 'dark' | 'light';
export interface SkeletonGroupProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  children?: ReactNode;
  /**
   * Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Effects the color of the Skeleton */
  skin?: SkeletonGroupSkin;
  /** The background on which the skeleton is rendered */
  backgroundColor?: string;
}
